export default "__VITE_ASSET__DM6K3_pr__"